import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { Document } from "../../../../../models/Document";
import { AppStateWithData } from "../../../../AppStateWithData";
import { constructSearchByIdsQueryRequest, SearchQueryRequest } from "./constructDocumentsQuery";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { collaborationService } from "../../../../../services";

export const fetchDocumentsActionTypes = createRequestActionTypes('FETCH_DOCUMENTS')

interface SearchByIdsResponse {
    data: { Value: { Source: Document } }[]
}

export interface FetchDocumentAdditionalData {
    docIds: string[]
    userUid?: string
    logClick?: boolean
}

export type FetchDocumentsOptions = {
    userUid?: string
    logClick?: boolean
    logClickAction?: (docId: string) => void
}

const executeCallActionBeforeFetch = (docIds: string[], options?: FetchDocumentsOptions) => {
    if(!options?.logClick || docIds.length !== 1) return undefined

    const mainDocId = docIds?.[0] ?? ''
    if(!!options.logClickAction && typeof options.logClickAction === 'function') return async () => {
        await options?.logClickAction?.(mainDocId)
    }
    return async () => {
        await collaborationService.logClick(mainDocId)
    }
}

export const fetchDocuments = (config: ApiConfig) => (docIds: string[], options?: FetchDocumentsOptions) => (dispatch: Dispatch, getState: () => AppStateWithData) => {

    executeCallActionBeforeFetch(docIds, options)?.()
    const thunkParams: RequestThunkParameters<Document[], SearchQueryRequest, FetchDocumentAdditionalData> = {
        method: 'POST',
        requestActionTypes: fetchDocumentsActionTypes,
        actionAdditionalData: {
            docIds,
            userUid: options?.userUid,
            logClick: options?.logClick,
        },
        url: `${config.API_URL}/search/SearchByIds`,
        body: constructSearchByIdsQueryRequest(docIds),
        processResultBeforeDispatch: (result: SearchByIdsResponse): Document[] => {
            return result.data.map(x => x.Value.Source)
        }
    }

    dispatch<any>(createRequestThunk(thunkParams))
}